// extracted by mini-css-extract-plugin
module.exports = {"navBarItem":"Sidebar_navBarItem__289DZ","icon":"Sidebar_icon__1wgez"};